import { render, staticRenderFns } from "./UsersPrivilegeExpenses.vue?vue&type=template&id=0ceab362&scoped=true&"
import script from "./UsersPrivilegeExpenses.vue?vue&type=script&lang=js&"
export * from "./UsersPrivilegeExpenses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ceab362",
  null
  
)

export default component.exports